import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
export const isTransientError = (error)=>{
    const status = new ErrorResponse(error).status;
    return status == null || status >= 500;
};
